import api from "../api";

import { importFetchedStatuses } from "./importer";

//  Servers without Mastodon's quote API (e.g. GoToSocial) only deliver the
//  "RE: <link>" fallback paragraph. Resolve that link to a status ourselves.
const cache = new Map();

export const resolveQuoteUrl = (url) => (dispatch, getState) => {
  if (!cache.has(url)) {
    const request = api(getState).get("/api/v2/search", {
      params: { q: url, resolve: true, limit: 1, type: "statuses" },
    }).then(response => {
      const status = response.data.statuses && response.data.statuses[0];

      if (!status) {
        return null;
      }

      dispatch(importFetchedStatuses([status]));
      return status.id;
    }).catch(() => {
      cache.delete(url);
      return null;
    });

    cache.set(url, request);
  }

  return cache.get(url);
};
